import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithAuth } from './baseQuery'

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'User',
    'Outlet',
    'ActiveOrders',
    'ReadyOrders',
    'TodayOrders',
    'Order',
    'Menu',
    'Positions',
  ],
  endpoints: () => ({}),
})
